module.exports = __webpack_public_path__ + "img/og-image_handbook_en.7fc84b9.jpg";